import React, { useState } from "react";
import CardHeader from "../../../../../Universal/CardHeader.component";
import SelectFilter from "../../../../UniversalComponents/SelectFilter.component";
import Title from "../../../../../Universal/Title.component";
import DropDownInput from "../../../../../Universal/DropDownInput.component";
import GraphLegends from "../../../../../Universal/GraphLegends.component";
import "../../../../../../styles/ComponentsStyles/Operational/Residential/Hostel/HostelPreviewCard.style.css";
import PieChartComponent from "../../../../../Universal/PieChart.component";
import TestImg from "../../../../../../assets/Images/TestImg/profileImage.png";
import RoundedImg from "../../../../../Universal/RoundedImg.component";
const HostelPreviewCard = ({ onViewDetails }) => {
  // eslint-disable-next-line
  const [staffAttendance, setStaffAttendance] = useState([
    {
      name: "Security",
      color: "#0088FE",
      totalPerson: "20",
      totalAttandence: "12",
    },
    {
      name: "Food staffs",
      color: "#00C49F",
      totalPerson: "35",
      totalAttandence: "16",
    },
    {
      name: "Sweeper",
      color: "#FFBB28",
      totalPerson: "25",
      totalAttandence: "18",
    },
    {
      name: "Clerks",
      color: "#FF8042",
      totalPerson: "30",
      totalAttandence: "29",
    },
    {
      name: "Teachers",
      color: "#FF0000",
      totalPerson: "40",
      totalAttandence: "20",
    },
    {
      name: "Others",
      color: "#800080",
      totalPerson: "15",
      totalAttandence: "10",
    },
  ]);

  return (
    <div
      className="flex-col align-start p-1 h-full g-1 back-white radius-6"
      style={{ width: "30rem" }}
    >
      <CardHeader
        title="Hostel A"
        actionBtn={
          <div className="flex-row align-center justify-start g-2">
            <h3 style={{ color: "black" }}>Rooms: 08</h3>
            <button className="actionBtn" onClick={onViewDetails}>
              View Details
            </button>
          </div>
        }
      />

      <div className="flex-row align-center justify-between">
        <span className="poppins color-greenColor t-13">
          Attendance room wise
        </span>
        <SelectFilter />
      </div>

      <div className="w-full flex-row align-start justify-between g-1">
        <div
          className="flex-col align-start justify-start g-1"
          style={{ width: "30%" }}
        >
          <Title style={{ color: "black", fontSize: "14px" }}>
            Rooms with floor
          </Title>
          <div className="flex-col">
            <DropDownInput
              label={"Floor number"}
              type="select"
              name="filterRoom"
              suggestionList={["F1", "F2", "F3"]}
              setFieldValue={(val) => console.log(val)}
              placeholder={"Eg. F1"}
            />
          </div>
          <div className="hostelPreviewCardColorContainer">
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
            <GraphLegends label={"1"} color={"#FF5691"} />
          </div>
        </div>
        {/* chart and colors */}
        <div className="flex-row align-center justify-end flex-1 w-full">
          <PieChartComponent
            data={staffAttendance}
            width={240}
            height={250}
            valueKey="totalPerson"
            nameKey="name"
            totalKey="totalAttandence"
          />
        </div>
      </div>
      {/* warden section */}
      <div
        className="flex-row align-center justify-between p-2 radius-6"
        style={{ border: "2px solid var(--greenColor)" }}
      >
        <label htmlFor="warden" className="poppins t-18">
          Warden :
        </label>
        <div className="flex-row align-center justify-start g-1">
          <RoundedImg width="3rem" height="3rem" src={TestImg} />
          <div className="flex-col align-start justify-start">
            <Title className="t-18 color-black">Akhtarul Sardar</Title>
            <span className="t-12 color-grayColor">#33459876</span>
          </div>
        </div>
      </div>
      {/* hostel card table */}
      <div
        className="w-full flex-col align-start justify-start g-1 p-1 radius-6 back-mainContentBack"
        style={{ height: "50vh" }}
      >
        <div className="flex-col align-start justify-start g-1">
          <div className="flex-row justify-between align-center">
            <Title className={"t-20"}>Absentees</Title>
            <div className="toggleBtn">
              <label htmlFor="staffs">Staffs</label>
              <input type="checkbox" />
            </div>
            <span className="t-13 poppins color-greenColor">56 person</span>
          </div>
          <hr className="w-full" color="black" />
        </div>
        <div className="flex-col align-start justify-start scroll-y pr-1">
          <ul
            style={{ listStyleType: "none" }}
            className="flex-col align-start justify-start g-1"
          >
            {[...Array(10)].map((_, index) => {
              return (
                <li
                  key={index}
                  className="flex-row align-center justify-between pb-05"
                  style={{ borderBottom: "2px solid black" }}
                >
                  <div className="flex-row align-center justify-start g-1">
                    <RoundedImg width="3rem" height="3rem" src={TestImg} />
                    <div className="flex-col align-start justify-start">
                      <Title
                        className="t-14 color-black"
                        style={{ fontSize: "15px" }}
                      >
                        Akhtarul Sardar
                      </Title>
                      <span className="t-12 color-grayColor">Today</span>
                    </div>
                  </div>
                  <span className="t-12 color-greenColor">Room 06</span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HostelPreviewCard;
